module.exports = {
  DPD_ADMIN: "dpdAdmin",
  ADD_DPD_USER: "addDPDUser",
  CUSTOMER_ADMIN: "customerAdmin",
  CUSTOMER_USER: "myDPD",
};
